var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_info",
    d: "M14,8a6,6,0,1,0,6,6A6,6,0,0,0,14,8Zm0,2.661a1.016,1.016,0,1,1-1.016,1.016A1.016,1.016,0,0,1,14,10.661Zm1.355,6.145a.29.29,0,0,1-.29.29H12.935a.29.29,0,0,1-.29-.29v-.581a.29.29,0,0,1,.29-.29h.29V14.387h-.29a.29.29,0,0,1-.29-.29v-.581a.29.29,0,0,1,.29-.29h1.548a.29.29,0,0,1,.29.29v2.419h.29a.29.29,0,0,1,.29.29Z",
    transform: "translate(-8 -8)",
    fill: "#a2c1d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIconInfo);
export default __webpack_public_path__ + "static/media/tooltip_icon_info.f9f80b27f3d434372b407d55fd7279d7.svg";
export { ForwardRef as ReactComponent };